import type { Distance, Margins, Point } from "@pdfking/math"
import { ToMargins } from "@pdfking/math"
import { ZERO_POINT } from "@pdfking/math/constants"

import type { PathPoint } from "#public"

import { DrawPath } from "./DrawPath"

/** A + on `center`: the line across and the line up, each arm as long as
 * `arms` gives it — the same all round, or edge by edge. */
export const Cross = (
  arms: Distance | Margins<Distance>,
  center: Point<Distance> = ZERO_POINT
): PathPoint[][] => {
  const { top, right, bottom, left } = ToMargins(arms)
  const { x, y } = center
  return [
    DrawPath([
      { x: (x - left) as Distance, y },
      { x: (x + right) as Distance, y },
    ]),
    DrawPath([
      { x, y: (y - bottom) as Distance },
      { x, y: (y + top) as Distance },
    ]),
  ]
}
